import { IDotDangKyNganh2 } from "../../model/response/quan-ly-nganh-2/IDotDangKyNganh2";
import { apiClient } from "../apiClient";

const DOT_DANG_KY_NGANH_2_ENDPOINT = 'dot-dang-ky-nganh-2';
export const dotDangKyNganh2Api = {
    SelectAll: () => apiClient.get(`${DOT_DANG_KY_NGANH_2_ENDPOINT}`),
    Insert: (data: IDotDangKyNganh2) => apiClient.post(`${DOT_DANG_KY_NGANH_2_ENDPOINT}`, data),
    Update: (id: number, data: IDotDangKyNganh2) => apiClient.put(`${DOT_DANG_KY_NGANH_2_ENDPOINT}/${id}`, data),
    Delete: (id: number) => apiClient.delete(`${DOT_DANG_KY_NGANH_2_ENDPOINT}/${id}`),
}